import type { WorkspaceAccount } from "./account-workspace";

export type WorkspaceAccessKind = "membership" | "authorization" | null;

/**
 * 根据 URL accountId 与账户列表，解析当前工作区账户。
 * 代管项须在首帧即可从列表得出，不能等 effect 写入 state，否则 Gate 会误跳回自有账户。
 */
export function resolveWorkspaceAccount({
  accounts,
  accountId,
  authorizedAccount = null,
  authorizationDenied = false,
}: {
  accounts: WorkspaceAccount[];
  accountId: string;
  /** API 校验后的代管账户（可覆盖列表乐观项） */
  authorizedAccount?: WorkspaceAccount | null;
  /** 代管详情 API 已确认无权限时，不再乐观使用列表项 */
  authorizationDenied?: boolean;
}): { account: WorkspaceAccount | null; accessKind: WorkspaceAccessKind } {
  if (!accountId) {
    return { account: null, accessKind: null };
  }

  const membershipAccount =
    accounts.find((item) => String(item.id) === accountId && item.access_kind !== "authorization") ??
    null;
  if (membershipAccount) {
    return { account: membershipAccount, accessKind: "membership" };
  }

  if (authorizationDenied) {
    return { account: null, accessKind: null };
  }

  const listedAuthorized =
    accounts.find((item) => String(item.id) === accountId && item.access_kind === "authorization") ??
    null;
  const enriched =
    authorizedAccount && String(authorizedAccount.id) === accountId ? authorizedAccount : null;
  const account = enriched ?? listedAuthorized;

  return {
    account,
    accessKind: account ? "authorization" : null,
  };
}
